import axios from 'axios'
import {RsMessage} from 'redstarcloud-ui'
import utils from './utils'
import store from "@/store";
import redirect from '@/webconfig'
import $ from 'redstarcloud-ui'

function loadingShowOrHide(show) {
    if (show) {
        utils.showLoading()
    } else {
        utils.hideLoading()
    }
}

axios.defaults.timeout = 15000
axios.defaults.withCredentials = true
axios.defaults.responseType = 'json'
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.get['If-Modified-Since'] = '0'
axios.defaults.cache = false
let oaCode = utils.getQueryString('code') || '';
console.log(oaCode)
// http response 拦截器
axios.interceptors.response.use(
    response => {
        // 接口拦截，用户未登陆
        if (response.data.type === 'no_login') {
            utils.noLogin()
			if(response.data.code == 403){
				localStorage.removeItem('shopVo')
				top.$message.error('登录超时')
				top.location.href='/#/paymentLogin'
			}
            // localStorage.removeItem('userInfo')
            // if(!oaCode) {
            //     top.location.href = top.location.href.split('/#/')[0] + '/#/login'
            //     // top.location.reload()
            // } else {
            //     top.location.href = `${redirect.baseUrl}/login`
            // }
            return
        // 接口拦截，后端抛出错误信息
        } else if(response.data.code !== 200){
            $.Message.error(response.data.message || "系统异常！");
           // alert(response.data.message)
            //top.$message.error(response.data&& response.data.message || '系统异常！');
            // RsMessage.error(response.data.message || '系统异常！');
            return Promise.reject(response.data)
        } else {
            return response
        }
    },
    error => {
        return Promise.reject(error.response&&error.response.data)   // 返回接口返回的错误信息
    })

/*
loading为true 调用这个api会打开loading，结束关闭
loading为false  调用只会关闭loading ,主要用于首次打开tab页面，关闭loading
loading为''或者不传  什么都不操作
 */
export default class Http {
    static send(config,loading) {
        const currentUrl = encodeURIComponent(window.location.href)
        const configs = Object.assign({
            headers: {
                'currentUrl': currentUrl,
                'L-A-Platform':'erp-web'//后端日志埋点渠道
            },
            timeout: 30000
        }, config)
        let user = store.state.oaQuery
        if (user && user.token) {
            configs.headers.token = user.token
            configs.headers.appId = user.appId
        }
        // configs.headers.Authorization =utils.getCookie("ESESSIONID")
        // console.log(document.cookie.match())
        if (loading) {
            loadingShowOrHide(true)
        }
        return axios(configs).then((res) => {
            if (loading === '' ||typeof loading == 'object' || loading === undefined) {
                // 什么都不操作
            } else {
                loadingShowOrHide()
            }
            return res
        }).catch((error) => {
  
            if (loading === '' ||typeof loading == 'object' || loading === undefined) {
                // 什么都不操作
            } else {
                loadingShowOrHide()
            }
            if (error) {
                switch (error.code) {
                    case 500:
                        top.$message.error(error.message || '系统异常！');
                        break;
                    case 404:
                        top.$message.error('网络异常！');
                        break;
                }
            }
            throw error
        })
    }

    static post(url, params = {}, loading) {
        const config = {
            method: 'post',
            url,
            data: params
        }
        return Http.send(config, loading)
    }

    static get(url, params = {}, loading) {
        let urlParams = []
        Object.keys(params).forEach((key) => {
            urlParams.push(`${key}=${encodeURIComponent(params[key])}`)
        })
        if (urlParams.length) {
            urlParams = `${url}?${urlParams.join('&')}`
        } else {
            urlParams = url
        }
        const config = {
            url: urlParams,
            params: {
                randomTime: new Date().getTime() // 防止缓存
            }
        }
        return Http.send(config, loading)
    }
}
